import React, { useState } from 'react';
 import {
   FormControl,
   Input,
   Button,
   Box,
   Select,
   Spinner,
   useToast,
   FormLabel,
 } from '@chakra-ui/react';
 import axiosInstance from '../../services/axios';
 import Tracks from './Tracks';

 const TrackForm = ({ service, id, setId, storefront, setStorefront }) => {
   const [items, setItems] = useState([]);
   const [loading, setLoading] = useState(false);
   const toast = useToast();

   const handleSubmit = async (e) => {
     e.preventDefault();
     setLoading(true);
     setItems([]);  // clear previous items

     try {
       const isApple = service === 'apple';
       let trackEndpoint;
       let albumEndpoint;

       if (service === 'spotify') {
         trackEndpoint = `/spotify/track/${id}`;
         albumEndpoint = `/spotify/album/tracks/${id}`;
       } else if (isApple) {
         trackEndpoint = `/apple/song/${storefront}/${id}`;
         albumEndpoint = `/apple/album/${storefront}/${id}`;
       } else {
         throw new Error('Unknown service');
       }

       const [trackResult, albumResult] = await Promise.allSettled([
         axiosInstance.get(trackEndpoint),
         axiosInstance.get(albumEndpoint),
       ]);

       if (
         trackResult.status === 'fulfilled' &&
         (!isApple || (trackResult.value.data?.data?.length ?? 0) > 0)
       ) {
         if (service === 'spotify') {
           setItems([trackResult.value.data]);
         } else {
           setItems(trackResult.value.data.data);
         }
       } else if (
         albumResult.status === 'fulfilled' &&
         (!isApple || (albumResult.value.data?.data?.length ?? 0) > 0)
       ) {
         if (service === 'spotify') {
           const albumData = albumResult.value.data.items;
           const responseTracks = await Promise.all(
             albumData.map(async (trackObj) => {
               const trackRes = await axiosInstance.get(`/spotify/track/${trackObj.id}`);
               return trackRes.data;
             })
           );
           setItems(responseTracks);
         } else {
           const albumData = albumResult.value.data.data[0];
           setItems(albumData.relationships.tracks.data);
         }
       } else {
         toast({
           title: 'Error',
           description: 'Neither track nor album could be found. Check your ID.',
           status: 'error',
           duration: 5000,
           isClosable: true,
         });
       }
     } catch (error) {
       console.error('Error detecting track vs. album:', error);
       toast({
         title: 'Error',
         description: error.message || 'An unexpected error occurred.',
         status: 'error',
         duration: 5000,
         isClosable: true,
       });
     } finally {
       setLoading(false);
     }
   };

   return (
     <Box>
       <form onSubmit={handleSubmit}>
         <FormControl mb={4}>
           <FormLabel>Track or Album ID</FormLabel>
           <Input
             type="text"
             value={id}
             onChange={(e) => setId(e.target.value)}
             variant="filled"
             placeholder="Enter Track or Album ID"
           />
         </FormControl>

         {service === 'apple' && setStorefront && (
           <FormControl mb={4}>
             <FormLabel>Storefront</FormLabel>
             <Select
               value={storefront}
               onChange={(e) => setStorefront(e.target.value)}
               variant="filled"
             >
               <option value="us">US</option>
               <option value="gb">GB</option>
             </Select>
           </FormControl>
         )}
         <Box display="flex" justifyContent="center" mt={2}>
           <Button mt={2} type="submit" isDisabled={loading} colorScheme="blue" transition="transform 0.2s" _hover={{ transform: 'scale(1.05)' }}>
             {loading ? <Spinner size="sm" /> :  'Fetch Data'}
           </Button>
         </Box>
       </form>



       {items.length > 0 && (
         <Tracks
           items={items}
           service={service}
           selectedStorefront={storefront}
         />
       )}
     </Box>
   );
 };

 export default TrackForm;